import React from 'react';
import Checkbox from 'src/common/refactoredComponents/checkbox/Checkbox';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import styled from 'styled-components';
import { isIpad, isMobileView } from 'src/utils/util';
import { sizes } from 'src/styles/Media.styled';
import { useTranslation } from 'react-i18next';
import { BROWN_FONT_COLOR, SEMANTIC_TEXT_SMALL_PX } from 'src/styles/fonts/MCFontConstants';


const QuantityRPCheckboxes = ({
    item,
    index,
    lotItem,
    lotItemIdx,
    lotSerialValueEntered,
    showTopLabel,
}) => {
    const { t } = useTranslation();
    const winWidth = window.innerWidth;
    return (
        <>
            <Container
                padding={
                    showTopLabel
                        ? isMobileView()
                            ? '0px'
                            : isIpad()
                            ? '0px'
                            : '0 15px 0 0px'
                        : '10px 12px 0'
                }
                marginTop={isMobileView() ? '0px' : isIpad() ? '0px' : '-5px'}
                marginLeft={isMobileView() ? '0px' : '0'}
            >
                {showTopLabel && (
                    <CustomLabel
                        fSize={
                            isMobileView() || winWidth <= sizes.smalDevice
                                ? '12px!important'
                                : '13px!important'
                        }
                        color={
                            isMobileView() || winWidth <= sizes.smalDevice
                                ? '#140F4B'
                                : '#3c3c3c'
                        }
                        opacity={
                            isMobileView() || winWidth <= sizes.smalDevice
                                ? '70%'
                                : '100%'
                        }
                        label={
                            isMobileView() || winWidth <= sizes.smalDevice
                                ? t('reportUsage.itemList.used')
                                : t('reportUsage.record.priceOverride.AccountOwnedList.index.used')
                        }
                        textAlign={'center'}
                    />
                )}
                <Checkbox 
                    checked={item?.usedQuantity || false}
                    onCheckboxSelectionChange={(e) =>
                        lotSerialValueEntered(
                            e,
                            item,
                            index,
                            lotItem,
                            lotItemIdx,
                            'usedChecked'
                        )
                    }
                    id="reportUsage-record-reportPayment-QuantityRPCheckboxes"
                    margin={'0px 5px 0 0'}
                    labelStyleObj={{
                        fontSize: SEMANTIC_TEXT_SMALL_PX,
                        color: BROWN_FONT_COLOR,
                    }}
                    background={'none'}
                    checkboxBorder={'1.5px solid #555555'}
                    alignItemDirection={'center'}
                    hoverEffect={'false'}
                    disableFocusEffect={'true'}
                    ariaLabel={
                        isMobileView() || winWidth <= sizes.smalDevice
                            ? t('reportUsage.itemList.used')
                            : t('reportUsage.record.priceOverride.AccountOwnedList.index.used')
                    }
                />
            </Container>
        </>
    );
};

export default QuantityRPCheckboxes;
const Container = styled.span`
    padding: ${({ padding }) => padding};
    margin-top: ${({ marginTop }) => marginTop};
    margin-left: ${({ marginLeft }) => marginLeft};
`;
